export default {
  computed: {
    activePath: function() {
      return this.$route.path;
    },
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/second-menu/script.js